import { useEffect, useState } from 'react';
import { useDrawer } from '../../../../shared/drawer';
import { useNavigate } from 'react-router-dom';
import { Table } from "../../../../elements/table";
import { PageBody } from '../../../../elements/page-body';
import { useStore } from '../../../../shared/store';
import { SegurosTabForm } from './seguros-tab-form';




export const SegurosTab = ({
    item,
    onAction
}: {
    item?: any;
    onAction: () => void;
}) => {
    const { open, close } = useDrawer();
    const { get, set } = useStore();
    const navigate = useNavigate();
    const [refresh, setRefresh] = useState<string | null>(null);


    const handleClose = () => {
        setRefresh(Date.now().toString());
        onAction();
        close();
        window.location.reload();
    };

    const handleNewAction = () => {
        open('common.form-title.new', <SegurosTabForm close={handleClose} vehicleId={item} />);
    };



    return (
        <>

            <PageBody
                newAction={handleNewAction}
                newActionTitle={'common.form-title.new'}
                title={'common.label.seguros'}
                //titleStatus={'OK'}

            >
                <Table
                    path={`/fleet/insurances/?vehicle=${item}&`}
                    deletePath={`/fleet/insurances/`}
                    callBeforeDrawerClosed={handleClose}
                    Form={SegurosTabForm}
                    withPagination
                    refresh={refresh}
                    headers={[
                        {
                            key: 'number',
                            label: 'common.label.numero-poliza',
                        },
                        {
                            key: 'cost',
                            label: 'common.label.costo',
                        },
                        {
                            key: 'start_date',
                            type: 'date',
                            label: 'common.label.fecha-inicio',
                        },
                        {
                            key: 'end_date',
                            type: 'date',
                            label: 'common.label.fecha-fin',
                        },
                        {
                            key: 'status',
                            type: 'status',
                            label: 'common.label.estado',
                        },
                    ]}
                />
            </PageBody>
        </>

    );
};